import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import api from "./router/api.js";
// 全局使用index.js 下的方法
Vue.prototype.$api = api;
import store from "./store";
import VideoPlayer from "vue-video-player";

import echarts from "echarts";
Vue.prototype.$echarts = echarts;

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import "video.js/dist/video-js.css";
//import "vue-video-player/src/custom-theme.css";
import Bus from "./library/bus/bus";

import XfProfileDefault from "@/components/xf-profile-default";

Vue.use(VideoPlayer);
Vue.use(Bus);

import http from "./library/http";
import * as filters from "./library/filters";
import * as directives from "./library/directives";
import Share from "vue-social-share";
Vue.use(Share);

Object.keys(filters).forEach(item => {
  Vue.filter(item, filters[item]);
});

Object.keys(directives).forEach(item => {
  Vue.directive(item, directives[item]);
});

Vue.prototype.$http = http;
Vue.prototype.$store = store;
import "./styles/index.scss";

Vue.component("no-data", XfProfileDefault);

Vue.use(ElementUI);

Vue.config.productionTip = false;
Vue.config.devtools = true; //开启devtools

//跳转后返回顶部;
router.afterEach(() => {
  window.scrollTo(0, 0);
});

router.beforeEach((to, from, next) => {
  /* 必须调用 `next` */
  if (to.meta.needJudgeLogin) {
    http.post("/api/common/login/GetUserInfo").then(res => {
      if (res.code == 1) {
        next();
      } else {
        router.push("/");
      }
    });
    return;
  }
  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
